/* 🤖 this file was generated by svg-to-ts */
export const siriusBullet: {
  name: 'bullet';
  data: string;
} = {
  name: 'bullet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="currentColor"/></svg>`
};
